import React, { useEffect, useRef, useState } from "react";

import { InfiniteBox, isInViewport } from "./constants";
import { InfiniteScrollingProps } from "./types";

export const INFINITE_SCROLL_DEFAULT_BATCH_SIZE = 10;

export const InfiniteScroll: React.FC<InfiniteScrollingProps> = ({
  hasMore,
  skeleton,
  handleAddItemsToScroll,
  children,
  batchSize = INFINITE_SCROLL_DEFAULT_BATCH_SIZE,
  gap = "10px",
  width = "100%",
  height = "100%",
  isParentLoading,
  horizontal = true,
  wrap = false,
}) => {
  const [isLoading, setIsLoading] = useState(isParentLoading);
  const elementRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    if (isInViewport(elementRef.current, containerRef.current, horizontal && !wrap) && hasMore) {
      setIsLoading(true);
      setTimeout(function handleTime() {
        handleAddItemsToScroll(children.length + batchSize);
      }, 100);
    }
  };

  useEffect(() => {
    setIsLoading(isParentLoading);
  }, [children.length, isParentLoading]);

  return (
    <InfiniteBox
      data-testid="infinite-scroll-wrapper"
      ref={containerRef}
      gap={gap}
      horizontal={horizontal}
      width={width}
      height={height}
      onScroll={handleScroll}
      wrap={wrap}
    >
      {children.map((child, index) => {
        return (
          <div
            key={index}
            ref={el => (children.length - 1 === index && !isLoading ? (elementRef.current = el) : null)}
          >
            {child}
          </div>
        );
      })}
      {isLoading ? (
        <React.Fragment>
          {Array.from({ length: batchSize }, (_, i) => i + 1).map((item, index) => {
            return (
              <div key={"skeleton" + index} id={"skeleton" + index}>
                {skeleton}
              </div>
            );
          })}
        </React.Fragment>
      ) : null}
    </InfiniteBox>
  );
};
